import { styled } from 'styled-components';

import { Button } from '#/components/Button/Button';
import { useEnvironment } from '#/contexts/UserEnvironmentContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { scrollToTop } from '#/utils/scroll';

const Holder = styled.footer`
  flex: 1;
  min-width: 106px;
  max-width: 162px;
`;

export function DesktopSearchBarSubmitButton() {
  const { i18n } = useI18n();

  const { environment } = useEnvironment();

  return (
    <Holder>
      <Button
        type="submit"
        variant="primary"
        icon={{ type: 'normalized', name: 'search' }}
        qaId="search-button"
        data-ready={Boolean(environment)}
        onClick={scrollToTop}
        height={48}
        fullWidth
      >
        {i18n('Search')}
      </Button>
    </Holder>
  );
}
